"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const mobx_react_lite_1 = require("mobx-react-lite");
const context_1 = require("../../../context");
const ErrorBoundary_1 = require("../../ErrorBoundary");
const CarouselSlidePosterImage_1 = tslib_1.__importDefault(require("../../../ui-lib/Carousel/CarouselSlidePosterImage"));
const MultistreamPosterImage = (0, mobx_react_lite_1.observer)(({ classes, publicKey }) => {
    const ctx = (0, react_1.useContext)(context_1.MultistreamContext);
    (0, ErrorBoundary_1.useUndefinedStoreError)(ctx != null, "<MultistreamCarouselSlide/>");
    // Using a hash param to force reload of poster image
    const posterUrl = (0, react_1.useMemo)(() => { var _a; return (publicKey != null ? `${(_a = ctx === null || ctx === void 0 ? void 0 : ctx.streams[publicKey]) === null || _a === void 0 ? void 0 : _a.posterUrl}&hash=${Date.now()}` : null); }, [ctx === null || ctx === void 0 ? void 0 : ctx.streams, publicKey]);
    return react_1.default.createElement(CarouselSlidePosterImage_1.default, { posterUrl: posterUrl, classes: classes });
});
/**
 *
 * @visibleName Multistream Poster Image
 */
// eslint-disable-next-line react/function-component-definition
const MultistreamPosterImageWithErrorBoundary = ({ classes, ...props }) => {
    return (react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, { render: () => react_1.default.createElement(CarouselSlidePosterImage_1.default, { classes: classes, posterUrl: null, ...props }) },
        react_1.default.createElement(MultistreamPosterImage, { classes: classes, ...props })));
};
exports.default = MultistreamPosterImageWithErrorBoundary;
//# sourceMappingURL=MultistreamPosterImage.js.map